import camelCaseKeys from "camelcase-keys";
import { CartItem, CartItemSchema } from "../Cart/schema";
import snakecaseKeys from "snakecase-keys";
import {
  authorizedPost,
  authorizedDelete,
  authorizedPatch,
} from "../authorizedRequests";

// Cart Item Requests

export interface CartItemModAttributesRequest {
  id?: string;
  delete?: boolean;
  itemModId: string;
  itemModGroupId: string;
  salesPriceId: string;
  modType: "optional" | "mandatory";
}
export interface CartItemRequest {
  id?: string;
  cartId: string;
  itemId: string;
  multiplier: number;
  salesPriceId: string;
  itemModsAttributes: CartItemModAttributesRequest[];
}
export const createCartItem = async (
  cartItemRequest: CartItemRequest
): Promise<CartItem> => {
  const { body } = await authorizedPost({
    url: `/v1/carts/${cartItemRequest.cartId}/items`,
    body: snakecaseKeys({ cartItem: cartItemRequest }, { deep: true }),
  });
  return CartItemSchema.parse(camelCaseKeys(body.cart_item, { deep: true }));
};

export const updateCartItem = async (
  cartItemRequest: Partial<CartItemRequest> & { id: string }
) => {
  const { body } = await authorizedPatch({
    url: `/v1/carts/${cartItemRequest.cartId}/items/${cartItemRequest.id}`,
    body: snakecaseKeys({ cartItem: cartItemRequest }, { deep: true }),
  });
  return CartItemSchema.parse(camelCaseKeys(body.cart_item, { deep: true }));
};
export const deleteCartItem = async (cartId: string, cartItemUuid: string) => {
  const { body } = await authorizedDelete({
    url: `/v1/carts/${cartId}/items/${cartItemUuid}`,
    body: {},
  });
  return CartItemSchema.parse(camelCaseKeys(body.cart_item, { deep: true }));
};
